// Category.js
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import CustomBar from "../../components/customBar";
import DynamicTable from "../../components/dynamicTable";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import TextInput from "../../components/textInput";
import { createCategory, fetchCategory } from "../../services/Category";
import { constants } from "../../theme/Variables";
import CustomDialog from "./CreateCategoryDialog";

const tableHeader = ["Category#ID", "Category NAME", "Created_At"];
const displayRows = ["_id", "Categorie_data", "created_at"];
const selectInputWidth = { width: { xs: "100%", md: "150px" } };
const headersForCsv = [
  { label: "Category#ID", key: "_id" },
  { label: "Category NAME", key: "name" },
  { label: "Created_At", key: "createdAt" },
];

function Category() {
  const openCategoryDialog = useRef();
  const [filterCategory, setFilterCategory] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState("");

  useEffect(() => {
    handleFetchAllCategories();
  }, []);

  useEffect(() => {
    filterAndSearchCategory();
  }, [searchValue, allCategory]);

  const filterAndSearchCategory = () => {
    if (!searchValue.trim()) {
      setFilterCategory(allCategory);
      return;
    }
    const filteredData = allCategory.filter((category) =>
      category?.name?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilterCategory(filteredData);
  };

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const handleFetchAllCategories = async () => {
    try {
      setIsLoading(true);
      const response = await fetchCategory();
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        setAllCategory(response?.data?.data || []);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.data?.message || "An error occurred");
      setIsLoading(false);
    }
  };

  const handleOpenCreateCategoryDialog = () => {
    openCategoryDialog.current.openDialog();
  };

  const handleCreateCategory = async () => {
    try {
      setIsLoading(true);
      const response = await createCategory({ name: inputValues });
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        openCategoryDialog.current.closeDialog();
        handleOpenSnackBar("success", response.data.message);
        setInputValues("");
        handleFetchAllCategories();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error.data.message);
      console.log(error, "errorerrorerrorerror");
    }
  };

  return (
    <NavigationDrawer>
      <CustomBar title="CATEGORIES" />
      <AppContainer>
        <Stack
          px={3}
          py={2}
          gap={2}
          direction={{ md: "row" }}
          alignItems="center"
        >
          <TextInput
            sx={{ flex: 1 }}
            placeholder="Search Vendors"
            InputStartIcon={
              <img src={APP_ICONS.searhIcon} width={20} alt="Search Icon" />
            }
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <Stack
            direction={{ sm: "row" }}
            width="100%"
            flex={2}
            gap={2}
            justifyContent={{ md: "flex-end" }}
          >
            <Button
              variant="contained"
              onClick={handleOpenCreateCategoryDialog}
              sx={{ height: 40, width: 100 }}
            >
              Add
            </Button>
            <CSVLink
              data={filterCategory}
              headers={headersForCsv}
              filename="filtered-users.csv"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <Box
                height={40}
                bgcolor={"#003B95"}
                borderRadius={2}
                sx={{ width: { xs: "100%", md: 120 } }}
              >
                <Button>
                  <Typography color="#FFF">Export</Typography>
                </Button>
              </Box>
            </CSVLink>
          </Stack>
        </Stack>
        <Divider />
        {filterCategory.length > 0 ? (
          <DynamicTable
            tableData={filterCategory ? filterCategory : allCategory}
            displayRows={displayRows}
            tableHeader={tableHeader}
            showEditAndDelete={true}
            showPagination={true}
          />
        ) : (
          <Typography
            color="black"
            fontSize={14}
            fontWeight={700}
            textAlign="center"
            padding="30px 0"
          >
            No Categories Found!
          </Typography>
        )}
      </AppContainer>
      <Loader isloading={isLoading} />
      <CustomDialog
        ref={openCategoryDialog}
        inputValues={inputValues}
        handleChange={setInputValues}
        handleCreate={handleCreateCategory}
      />
    </NavigationDrawer>
  );
}

export default Category;
